import React from "react";
import { CompanyCardContainer } from "./CompanyCardStyled";
import avatar from './../../utils/images/avatar_fluincr.png';
import { useNavigate } from 'react-router-dom';
import { useContext } from "react";
import { UserContext } from "../../context/userContext";
import { LangContext } from "../../context/langContext";

export default function CompanyCard({ company, page }) {

    const { locale } = useContext(LangContext);
    const navigate = useNavigate();
    const { userToken, userType } = useContext(UserContext);

    const handlerSeeCompany = () => {
        if (userToken === null) {
            navigate(`/signin`)
        } else {
            if (userType === 'influencer') {
                navigate(`/${company.username}`)
            }
        }

    }

    return (
        <CompanyCardContainer page={page}>
            <div className="logo" style={{ backgroundImage: `url(${(company.imageprofile !== null) ? company.imageprofile : avatar})` }}>

            </div>

            <h3 className="name" onClick={handlerSeeCompany}>{company.namecompany}</h3>

            <div className="companyData">
                <img src={company?.imagecountry} alt="" className="companyCountry" />
                <div className="categories">
                    {(locale === 'es-CO') ? (company?.nombrecategory?.map((category, index) => {
                        if (index < 3) {
                            return (
                                <span className="category">#{category}</span>
                            )
                        }

                    })) : (company?.namecategory?.map((category, index) => {
                        if (index < 3) {
                            return (
                                <span className="category">#{category}</span>
                            )
                        }

                    }))}
                </div>
            </div>

        </CompanyCardContainer>
    )
}